export default __webpack_public_path__ + "static/media/form.265adb45.svg";